document.addEventListener('DOMContentLoaded', function () {
	AOS.init({
		once: true,
		duration: 800
	});
});
